import { PreviewTabIcon } from './PreviewIcons';

export default function AccordionCard({ id, title, open, onToggle, iconStyle, children }) {
  return (
    <div className={open ? 'preview-accordion-card open' : 'preview-accordion-card'}>
      <button className='preview-accordion-trigger' type='button' onClick={onToggle}>
        <span className={`preview-card-icon icon-${id}`} style={iconStyle || undefined}>
          <PreviewTabIcon tabId={id} />
        </span>
        <span className='preview-card-copy'>
          <strong>{title}</strong>
        </span>
        <span className='preview-card-chevron'>›</span>
      </button>
      <div className='preview-accordion-body'>{children}</div>
    </div>
  );
}
